import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MetaService } from '../../../meta.service';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { PaintDirective } from '../../../paint.directive';

@Component({
  selector: 'get-app',
  templateUrl: './get-app.component.html',
  styleUrls: ['./get-app.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatListModule, MatIconModule, PaintDirective]
})
export default class GetAppComponent {
  activated = inject(ActivatedRoute);
  meta = inject(MetaService);

  headerText: string = 'Free. Instant.'
  boxText: string = 'Why choose cloudigo?'
  features: string[] = [
    "It helps you save money",
    "It's free to download",
    "Over 350+ brands to choose from",
    "Includes Premium plans for bigger savings",
  ];

  constructor() {
    let title: string = 'cloudigo Malta - Download the cloudigo App for instant access to discounts and offers!';
    
    if(this.activated.snapshot.url.toString().includes('upgrade')){
      title = 'cloudigo Malta - Update the cloudigo App for instant access to discounts and offers!';
      this.headerText = 'Meet the new cloudigo';
      this.features = [
        "Upgraded design",
        "Easier access to instant discounts",
        "Now available on your smartphone as an app",
        "It's still free"
      ];
      this.boxText = 'Update the cloudigo app!';
    }
    this.meta.setTags(title, this.features.join('. '));
  }

}
